module.exports = __webpack_public_path__ + "static/media/nc.b5a86b60.svg";